// Thư mục: src/stores/dieuPhoiDonHangStore.js
import { defineStore } from "pinia";
import { DonHangApi } from "@/services/donHangService";
import { XePhanCongApi } from "@/services/xePhanCongService";

export const useDieuPhoiDonHangStore = defineStore("dieuPhoiDonHang", {
  state: () => ({
    // Tab 1: Hàng đợi (Pool)
    isLoadingPool: false,
    poolError: null,
    poolItems: [], // Đơn 'SAN_SANG_GIAO'
    poolPage: 0,
    poolSize: 10,
    poolTotalPages: 1,

    // Tab 2: Đang vận chuyển (Tracking)
    isLoadingRunning: false,
    runningError: null,
    runningItems: [], // Đơn 'DANG_VAN_CHUYEN'
    runningPage: 0,

    // Tab 3: Lệnh chờ (Tài xế/Xe đang rảnh)
    isLoadingPhanCong: false,
    phanCongError: null,
    phanCongOptions: [], // Lệnh 'ASSIGNED'

    // State chung
    isLoadingAction: false,
    actionError: null,
  }),
  getters: {
    // ...
  },
  actions: {
    // Tải Hàng Đợi (Pool)
    async fetchPool() {
      this.isLoadingPool = true;
      this.poolError = null;
      try {
        const params = { page: this.poolPage, size: this.poolSize };
        const data = await DonHangApi.listPool(params);
        this.poolItems = data.content || [];
        this.poolTotalPages = data.totalPages ?? 1;
      } catch (e) {
        this.poolError = e?.response?.data?.message || "Lỗi tải hàng đợi";
      } finally {
        this.isLoadingPool = false;
      }
    },

    // Tải các lệnh đang chờ (ASSIGNED)
    async fetchPhanCongOptions() {
      this.isLoadingPhanCong = true;
      this.phanCongError = null;
      try {
        this.phanCongOptions = await XePhanCongApi.getAssigned();
      } catch (e) {
        this.phanCongError = e?.response?.data?.message || "Lỗi tải lệnh chờ";
      } finally {
        this.isLoadingPhanCong = false;
      }
    },

    // Tải các đơn đang chạy (để theo dõi)
    async fetchRunning() {
      this.isLoadingRunning = true;
      this.runningError = null;
      try {
        const params = { page: this.runningPage, size: this.poolSize };
        const data = await DonHangApi.listDangVanChuyen(params);
        this.runningItems = data.content || [];
      } catch (e) {
        this.runningError =
          e?.response?.data?.message || "Lỗi tải đơn đang chạy";
      } finally {
        this.isLoadingRunning = false;
      }
    },

    // Gán (Ghép) đơn
    async assignOrders(phanCongId, orderIds) {
      this.isLoadingAction = true;
      this.actionError = null;
      try {
        await DonHangApi.adminAssignDonHang(phanCongId, orderIds);
        await this.fetchPool(); // Tải lại Pool (vì đơn đã bị gán)
      } catch (e) {
        this.actionError = e?.response?.data?.message || "Lỗi gán đơn";
        throw e;
      } finally {
        this.isLoadingAction = false;
      }
    },
  },
});
